import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { BrandLogo } from '../components/BrandLogo';
import { APP_SCHEME } from '../utils/nativeAuth';

// Opened in the phone's browser after Google sign-in; hands the session back to the app
export default function AppReturn() {
  const location = useLocation();
  const appLink = useMemo(() => `${APP_SCHEME}://auth${location.hash}`, [location.hash]);

  useEffect(() => {
    if (location.hash.includes('session_id=')) window.location.href = appLink;
  }, [appLink, location.hash]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#092143] text-white" data-testid="app-return-page">
      <div className="max-w-sm text-center space-y-6">
        <div className="w-20 h-20 mx-auto rounded-2xl overflow-hidden shadow-lg"><BrandLogo className="w-full h-full" /></div>
        <h1 className="text-2xl font-bold">You're signed in</h1>
        <p className="text-blue-100 text-sm">Returning you to the Legacy Forge app...</p>
        <a
          href={appLink}
          className="inline-block px-6 py-3 rounded-full bg-white text-[#092143] font-semibold"
          data-testid="app-return-open-btn"
        >
          Open the app
        </a>
      </div>
    </div>
  );
}
